import type { ConversationCardRendererProps } from 'src/modules/communications/types/conversation-card.type';
import { useClientType } from 'src/modules/shared/hooks/use-client-type';
import { ConversationCard } from './card';
import { LegacyConversationCard } from './legacy-card';

/**
 * Selects the regular card for resolved real-estate tenants and preserves the
 * existing card for all other tenants.
 *
 * @param props - Card content, callbacks, and optional drag-overlay cache mode.
 * @returns The client-type-appropriate conversation card.
 */
export const ConversationCardRenderer: React.FC<
  ConversationCardRendererProps
> = ({
  conversation,
  isSelected,
  onClick,
  className,
  layout = 'list',
  onOpenDetails,
  cacheOnly = false,
}) => {
  const clientType = useClientType();

  if (clientType !== 'REAL_ESTATE') {
    return (
      <LegacyConversationCard
        conversation={conversation}
        isSelected={isSelected}
        onClick={onClick}
        className={className}
        layout={layout}
        onOpenDetails={onOpenDetails}
      />
    );
  }

  return (
    <ConversationCard
      conversation={conversation}
      isSelected={isSelected}
      onClick={onClick}
      className={className}
      onOpenDetails={onOpenDetails}
      showStatus={layout === 'list'}
      cacheOnly={cacheOnly}
    />
  );
};
